export const LAST_SEEN_THRESHOLD_MINUTES = 30;
